<header>

  <nav class="navbar navbar-expand-md bg-light justify-content-center fixed-top">
    <div class="container-fluid">
      <!-- <button
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarExample01"
        aria-expanded="false"
        aria-controls="navbarExample01"
        aria-label="Toggle navigation"
        class="btn  d-md-none"
      >
       <fa-icon [icon]="['fas', 'bars']"></fa-icon>
      </button> -->
      <button
        type="button"
        (click)="toggleNavbar(navbarCollapse)"
        class="btn d-md-none"
      >
        <fa-icon [icon]="['fas', 'bars']"></fa-icon>
      </button>
      <div class="collapse navbar-collapse" id="navbarExample01" #navbarCollapse>
        <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
          <li class="nav-item active">
            <button class="nav-link btn btn-link" (click)=" '#'; closeNavbar(navbarCollapse)">Home</button>
          </li>
          <li class="nav-item">
            <button class="nav-link btn btn-link" (click)="closeNavbar(navbarCollapse)">Features</button>
          </li>
          <li class="nav-item">
            <button class="nav-link btn btn-link"  (click)="closeNavbar(navbarCollapse)">Pricing</button>
          </li>
          <li class="nav-item">
            <button class="nav-link btn btn-link"  (click)="closeNavbar(navbarCollapse)">About</button>
          </li>
          <li class="nav-item">
            <!-- <a class="nav-link " (click)=" login(); closeNavbar(navbarCollapse)">Login</a> -->
            <button class="nav-link btn btn-link" (click)="login(); closeNavbar(navbarCollapse)">Login</button>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</header>
<div>
    <router-outlet></router-outlet>
</div>

<!-- <div class="container mt-4">

  <button
    class="btn btn-primary"
    type="button"
    data-bs-toggle="collapse"
    data-bs-target="#exampleCollapse"
    aria-expanded="false"
    aria-controls="exampleCollapse">
    Toggle Content
  </button>


  <div class="collapse mt-3" id="exampleCollapse">
    <div class="card card-body">
      This is the collapsible content. It will be shown or hidden when the button is clicked.
    </div>
  </div>
</div> -->